import {getRouteApi} from "@tanstack/react-router";

export const expedientNotesRouteApi = getRouteApi("/_app/sales/expedients/$expedientId/notes/");
